import React from "react";
import { CcButton, CcIconButton } from "../mui";
import {
  CcButtonIcon,
  CcIconDocumentAdd,
  CcIconDocumentEdit,
  CcIconEdit,
  CcIconTrash,
} from "../../icons";
import { cx } from "../utils";

/**
 * CcCarePlanFormActions — care plan assessment header toolbar.
 * Uses themed CcButton / CcIconButton per Zen Editorial v2.1.
 *
 * | Control        | Component     | Variant        | Icon              |
 * |----------------|---------------|----------------|-------------------|
 * | View document  | CcIconButton  | secondary (sm) | CcIconDocumentEdit|
 * | + New Version  | CcButton      | primary (sm)   | CcIconDocumentAdd |
 * | Archive        | CcButton      | dangerOutline (sm) | CcIconTrash   |
 */
const CcCarePlanFormActions = ({
  className,
  showDocument = true,
  onViewDocument,
  canCreateVersion = false,
  hasDraftInProgress = false,
  onContinueDraft,
  onCreateNewVersion,
  showEvaluate = false,
  onEvaluate,
  showArchive = false,
  onArchive,
  isVersioningApplicable = true,
}) => (
  <div className={cx("cc-care-plan-form-actions", className)}>
    {showDocument && onViewDocument && (
      <CcIconButton
        label="View document"
        variant="secondary"
        size="sm"
        onClick={onViewDocument}
      >
        <CcIconDocumentEdit size={18} />
      </CcIconButton>
    )}

    {canCreateVersion &&
      isVersioningApplicable &&
      (hasDraftInProgress ? (
        <CcButton
          variant="secondary"
          size="sm"
          startIcon={
            <CcButtonIcon>
              <CcIconEdit size={16} />
            </CcButtonIcon>
          }
          onClick={onContinueDraft}
        >
          Continue Draft
        </CcButton>
      ) : (
        <CcButton
          variant="primary"
          size="sm"
          startIcon={
            <CcButtonIcon>
              <CcIconDocumentAdd size={16} />
            </CcButtonIcon>
          }
          onClick={onCreateNewVersion}
        >
          New Version
        </CcButton>
      ))}

    {showEvaluate && (
      <CcButton
        variant="secondary"
        size="sm"
        startIcon={
          <CcButtonIcon>
            <CcIconDocumentAdd size={16} />
          </CcButtonIcon>
        }
        onClick={onEvaluate}
      >
        Evaluate
      </CcButton>
    )}

    {showArchive && onArchive && (
      <CcButton
        variant="dangerOutline"
        size="sm"
        startIcon={
          <CcButtonIcon>
            <CcIconTrash size={16} />
          </CcButtonIcon>
        }
        onClick={onArchive}
      >
        Archive
      </CcButton>
    )}
  </div>
);

export default CcCarePlanFormActions;
